import { Modal, Textarea, Button } from "flowbite-react";
import { useEffect, useState } from "react";
import { getLogsByEntity } from "@/common/services/logs.api";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import Loading from "@/common/components/ui/loading/Loading";
import GenericTable from "@/common/components/ui/table/GenericTable";
import { formatDateAndTime } from "@/common/helpers/date.helpers";
import { ILog, LogMessageTranslations } from "@/types/logs.type";

type ModalMetaProps = {
  meta: object;
  onClose: () => void;
};

function ModalMetaDetails({ meta, onClose }: ModalMetaProps) {
  return (
    <Modal size="2xl" show={true} onClose={onClose} popup>
      <Modal.Header />
      <Modal.Body>
        <div className="space-y-4">
          <h3 className="text-xl font-medium text-gray-900 text-black">
            Metadados (JSON)
          </h3>
          <Textarea
            readOnly
            color={"black"}
            className="w-full h-96 font-mono text-sm bg-gray-50 border-gray-300 text-black"
            defaultValue={
              meta && Object.keys(meta).length > 0
                ? JSON.stringify(meta, null, 2)
                : ""
            }
          />
          <div className="w-full flex justify-end">
            <Button color="red" onClick={onClose}>
              Fechar
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

type Props = {
  onClose: () => void;
  entity: string;
  entityId: string;
};

const headers = {
  timestamp: "Data",
  message: "Mensagem",
  meta: "Detalhes",
};

const translateMessage = (message: string): string => {
  // Retorna a tradução se existir, senão, retorna a mensagem original
  return LogMessageTranslations[message] || message;
};

export function ModalViewLogs({ onClose, entity, entityId }: Props) {
  const { notifyError } = useToastContext();
  const [logs, setLogs] = useState<ILog[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedMeta, setSelectedMeta] = useState<object | null>(null);

  useEffect(() => {
    async function fetchLogs() {
      if (!entity || !entityId) return;
      setIsLoading(true);
      try {
        const result = await getLogsByEntity({ entity, entityId });

        if (result.ok && Array.isArray(result.data)) {
          setLogs(result.data);
        } else {
          notifyError(result.message || "Erro ao carregar histórico.");
        }
      } catch (err) {
        notifyError((err as Error).message);
      } finally {
        setIsLoading(false);
      }
    }
    fetchLogs();
  }, [entity, entityId, notifyError]);

  return (
    <>
      <Modal size="7xl" show={true} onClose={onClose}>
        <Modal.Header>
          <h2 className="text-black">Histórico de Alterações</h2>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <Loading />
          ) : logs.length > 0 ? (
            <GenericTable
              headers={headers}
              data={logs}
              renders={{
                timestamp: (date) => formatDateAndTime(date),
                message: (message) => translateMessage(message as string),
                meta: (metaData) => (
                  <Button
                    size="xs"
                    onClick={() => setSelectedMeta(metaData as object)}
                  >
                    <p className="text-black">Ver Detalhes</p>
                  </Button>
                ),
              }}
            />
          ) : (
            <p>Nenhum histórico encontrado para este item.</p>
          )}
        </Modal.Body>
      </Modal>

      {selectedMeta && (
        <ModalMetaDetails
          meta={selectedMeta}
          onClose={() => setSelectedMeta(null)}
        />
      )}
    </>
  );
}
